/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsSquareWord: {
  name: 'square-word';
  data: string;
} = {
  name: 'square-word',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 .5A1.5 1.5 0 0 0 .5 2v12A1.5 1.5 0 0 0 2 15.5h12a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 14 .5H2ZM1.5 2a.5.5 0 0 1 .5-.5h12a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5V2Zm2.974 2.842a.5.5 0 1 0-.948.316l2 6a.5.5 0 0 0 .89.12L8 8.9l1.584 2.376a.5.5 0 0 0 .89-.119l2-6a.5.5 0 1 0-.948-.316l-1.677 5.03-1.433-2.15a.5.5 0 0 0-.832 0l-1.433 2.15-1.677-5.03Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
